import React from 'react';
import './WhatsAppWidget.css';

const WhatsAppWidget = () => {
    return (
        <a
            href="https://wa.me/9716164470"
            className="whatsapp_float"
            target="_blank"
            rel="noopener noreferrer"
        >
            <i className="fa-brands fa-whatsapp whatsapp-icon"></i>
        </a>
    );
};

export default WhatsAppWidget;
